import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import { createGtm } from 'vue-gtm';
import '@/thirdpartyjs/typekit.js'

const app = createApp(App);
app.use(router).use(store)

app.use(createGtm({
  id: 'GTM-PBWMB84B', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  queryParams: { // Add url query string when load gtm.js with GTM ID (optional)

  },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
}));

const requireComponent = require.context(
  // コンポーネントフォルダの相対パス
  './components',
  // サブフォルダ内を調べるかどうか
  false,
  // 基底コンポーネントのファイル名に一致させるのに使う正規表現
  /[A-Z]\w+\.(vue|js)$/
)
console.log(requireComponent)
requireComponent.keys().forEach(fileName => {
const componentConfig = requireComponent(fileName)

const componentName = upperFirst(
    camelCase(
        fileName
            .split('/')
            .pop()
            .replace(/\.\w+$/, '')
    )
)

app.component(
    componentName,

    componentConfig.default || componentConfig
)
})

app.mount('#app')